import { render } from "./PageNotification.vue?vue&type=template&id=776e406e&scoped=true"
import script from "./PageNotification.vue?vue&type=script&lang=js"
export * from "./PageNotification.vue?vue&type=script&lang=js"

import "./PageNotification.vue?vue&type=style&index=0&id=776e406e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3963854441/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776e406e"]])

export default __exports__